import PropTypes from "prop-types";
import { idPropType } from "./id-prop-type";

export const productCategoryPropType = PropTypes.shape({
  id: idPropType,
  attributes: PropTypes.object, // we can probably do better
  displayName: PropTypes.string,
  facets: PropTypes.object,
  parent: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.object),
});
